import PermissionElementWrapper from '../../pages/PermissionControls/PermissionElementWrapper';
import { SecondaryButton } from '../Button';
import { LlmSubjectKind } from '../../utils/apollo/graphqlSchema';

interface IProps {
  subjectKind: LlmSubjectKind;
  onClick?: () => void;
  isPermitted: boolean;
  isDisabled: boolean;
  trackAction: string;
  trackContext: string;
}

const saveText: Record<LlmSubjectKind, string> = {
  [LlmSubjectKind.Analysis]: 'Save to Report',
  [LlmSubjectKind.Dashboard]: 'Save to Dashboard',
};

const ExplainWithAiSaveButtonDisplay = ({
  subjectKind,
  isPermitted,
  isDisabled,
  trackAction,
  trackContext,
  onClick,
}: IProps) => {
  return (
    <PermissionElementWrapper isPermitted={isPermitted}>
      <SecondaryButton
        onClick={onClick}
        disabled={isDisabled}
        isOutlined={true}
        trackContext={trackContext}
        trackAction={trackAction}
      >
        {saveText[subjectKind]}
      </SecondaryButton>
    </PermissionElementWrapper>
  );
};

export default ExplainWithAiSaveButtonDisplay;
